import canvas from '@classes/canvas'

import { divideIfNotZero } from '../helper/canvasDraw'
import type { MainParams, StyleParams } from '../Meter'
import type { GaugeDrawResult } from './gauge_types'

export function drawTemperatureGauge (main: MainParams, style: StyleParams, size: number, seaTemp?: number, layout?: string): GaugeDrawResult {
  const { prevValue, maxValue, value, ctx, redraw, dpx, center, radius, unit, currentValue } = main
  const { arcColor, color } = style

  let newCurrentValue: number = currentValue
  const from = divideIfNotZero(Number(prevValue), Number(maxValue)) * 100
  const to = divideIfNotZero(100, Number(maxValue)) * Number(value)

  const drawing = (current: number) => {
    newCurrentValue = Number(Number(maxValue) * (current / 100))

    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height)
    redraw()
    canvas.drawWave(ctx, dpx, size - dpx * 1.5, size - dpx * 1.5, arcColor)
    canvas.drawArc(ctx, center, center, radius, 0, Math.PI * 2, arcColor, dpx + 1)
    canvas.drawValue(ctx, center, center / 2, newCurrentValue.toFixed().toString() + unit, 14 * dpx, color)

    if (seaTemp !== undefined && seaTemp > 0) {
      canvas.drawValue(
        ctx,
        center,
        center + center / 2,
        seaTemp.toFixed().toString() + unit,
        14 * dpx,
        layout === 'grid' ? '#72879f' : arcColor
      )
    }
  }

  const animateId = canvas.animate(from, to, drawing, 2, 'temperature')

  return { animateId, newCurrentValue }
}
